<template>
  <div id="changeUsername">
    <v-container class="pa-0" v-if="preUrl">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left to="/admin/families" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="usernameForm">
      <v-container>
        <v-tabs class="xs12" style="width:100%" hide-slider grow>
          <v-tabs-slider color="#019d8c"></v-tabs-slider>
          <v-tab v-for="(type, i) of ['Username', 'Display Name']" :key="i" class="justify-space-around">
            {{ type }}
          </v-tab>
          <v-tab-item transition="slide-x-transition" reverse-transition="slide-x-transition">
            <v-layout wrap row>
              <v-flex xs12 sm8>
                <v-text-field v-model="family.username" label="Username" class="pr-4 pl-4" disabled></v-text-field>
                <v-text-field browser-autocomplete="new-username" @keydown.space="(event) => event.preventDefault()" v-model.trim="newUsername" :rules="[rules.required, rules.noSpace]" label="New Username"
                class="required pr-4 pl-4" @input="changedUsername"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap class="pr-4 pl-4">
              <v-flex xs12 class="button-container pr-0 text-xs-right ">
                <div class="d-inline-flex" v-if="selectedUsername">
                  <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons('selectedUsername')">
                    <v-icon size="16" class="pr-1">cancel</v-icon>
                    <div>Cancel</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save" @click="saveUsername">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Save</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item transition="slide-x-transition" reverse-transition="slide-x-transition">
            <v-layout wrap row>
              <v-flex xs12 sm8>
                <v-text-field v-model="family.nickname" label="Display Name" class="pr-4 pl-4" disabled></v-text-field>
                <v-text-field browser-autocomplete="new-displayname" v-model.trim="newDisplayName" @keydown.space="(event) => event.preventDefault()" :rules="[rules.required, rules.noSpace]" label="New Display Name" class="required pr-4 pl-4" @input="changedDisplayName" :disabled="pendingRequest && pendingRequest.status === 'Pending'"></v-text-field>
                <span class="pl-4 pf-text-teal" v-if="pendingRequest && pendingRequest.status === 'Pending'">Your request to change the display name to <strong>{{ pendingRequest.new_value }}</strong> is pending.</span>
              </v-flex>
            </v-layout>
            <v-layout wrap class="pr-4 pl-4">
              <v-flex xs12 class="button-container pr-0 text-xs-right ">
                <div class="d-inline-flex" v-if="selectedDisplayName">
                  <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons('selectedDisplayName')">
                    <v-icon size="16" class="pr-1">cancel</v-icon>
                    <div>Cancel</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save" @click="saveDisplayName">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Save</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session config store */
/* eslint-disable */
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { checkWPToken, requestToWPPF, getCollection, update, getOne, create } from '../../helpers/helpers';
import swal from 'sweetalert2';
export default {
  name: 'reset-password',
  data: () => ({
    config: config,
    newUsername: '',
    newDisplayName: '',
    userData: null,
    accountData: null,
    searchResultIndex: -1,
    usernameFlag: false,
    displayNameFlag: false,
    mapId: '',
    preUrl: false,
    family: {
      username: '',
      nickname: '',
      mappingId: '',
      userId: '',
      accountId: ''
    },
    recipientList: [],
    searchFamilyList: [],
    query: {
      family: ''
    },
    userType: 'Family',
    userList: [
      'Family',
      'Agency'
    ],
    show1: false,
    rules: {
      required: value => !!value || 'Field is required.',
      toRule: (v) => !!v || 'Please select user',
      noSpace: (v) => v.indexOf(' ') === -1 || 'White space is not allowed'
    },
    rulesAgency: [
      v => !!v || 'Agency is required'
    ],
    selectedUsername: false,
    selectedDisplayName: false,
    pendingRequest: null
  }),
  computed: {
    ...mapGetters(['Account', 'Agency']),
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    SearchResult: {
      set (value) {
        store.commit('setSearchResult', value);
      },
      get () {
        return store.state.SearchResult;
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    if (session.role() === 'admin') {
        if (!this.$route.params.preUrl) {
            this.$router.push({ path: `/admin/families` });
        } else {
            /* Set the Ids */
            this.setIds();
            await this.getAccount();
        }

    } else if (session.role() === 'parent') {
        this.accountData = JSON.parse(JSON.stringify(this.Account));
    }
    await this.getUser();
    await this.getPendingRequest();
    this.setFamily();
  },
  methods: {
    setIds () {
        this.family.userId = this.$route.params.item.userId;
        this.family.accountId = this.$route.params.item.accountId;
        if (this.$route.params.item.searchResultIndex > -1) {
            this.searchResultIndex = this.$route.params.item.searchResultIndex;
        }
    },
    setFamily () {
        this.family.username = this.userData.username;
        this.family.nickname = this.accountData.nickname;
        if (this.$route.params.preUrl && ['/admin/families'].indexOf(this.$route.params.preUrl) > -1) {
            this.preUrl = true;
        }
        if (this.family.username && this.family.username.length) {
            this.newUsername = this.family.username;
        }
        if (this.family.nickname && this.family.nickname.length) {
            this.newDisplayName = this.family.nickname;
        }
    },
    async getUser () {
        if (session.getSession().user.id || this.family.userId) {
            let { error, data } = await getOne('User',  session.role() === 'parent' ? session.getSession().user.id : this.family.userId);
            if (error) {
                console.log(error);
                this.snackbar = {
                    show: true,
                    color: 'red',
                    text: 'Failed to fetch the user data'
                };
            } else {
                this.userData = data;
            }
        }
    },
    async getPendingRequest () {
        if (this.accountData.id) {
          let where = { account: this.accountData.id, type: 'Nickname', status: { $in: ['Pending'] } };
          let { error, data } = await getCollection('DataUpdateRequest', true, 0, '', where);
          if (error) {
              console.log(error);
              this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'Failed to fetch the request data'
              };
          } else if (data && data.length) {
              this.pendingRequest = data[0];
              this.newDisplayName = this.pendingRequest.new_value ? this.pendingRequest.new_value : this.accountData.nickname;
          }
        }
    },
    async getAccount () {
        if (session.role() === 'parent') {
            this.accountData = this.Account;
        } else {
            if (this.family.accountId) {
                let { error, data } = await getOne('Account', this.family.accountId);
                if (error) {
                    console.log(error);
                    this.snackbar = {
                        show: true,
                        color: 'red',
                        text: 'Failed to fetch the account data'
                    };
                } else {
                    this.accountData = data;
                }
            }
        }
    },
    async saveUsername () {
      if (this.$refs.usernameForm.validate() && await checkWPToken() && this.newUsername.length) {
        if (await this.duplicateUserNameCheck()) {
          /* Update the username */
          let userPayload = JSON.parse(JSON.stringify(this.userData));
          userPayload.old_username = userPayload.username;
          userPayload.username = this.newUsername;
          userPayload.human = userPayload.human.id;
          userPayload.updated_from = 'username';
          let userResponse = await update('User', userPayload, userPayload._id);
          if (userResponse.error) {
            this.snackbar = {
              show: true,
              color: 'red',
              text: `Failed to update the username, ${userResponse.error}`
            };
          } else {
            /* Update the state - SearchResult */
            if (this.searchResultIndex > -1) {
              this.SearchResult[this.searchResultIndex].human[0].user.username = this.newUsername;
            }
            swal.fire({
              type: 'success',
              title: '<b>Success</b>',
              html: 'The username was updated successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: async () => {
                this.userData = userResponse.data;
                this.family.username = this.newUsername;
                if (this.preUrl) {
                  this.$router.push({ path: '/admin/families' });
                } else {
                  this.usernameFlag = false;
                  this.selectedUsername = false;
                }
              }
            });
          }
        }
      }
    },
    async saveDisplayName () {
      if (this.$refs.usernameForm.validate() && await checkWPToken() && this.newDisplayName.length) {
        if (await this.duplicateDisplayNameCheck()) {
          if (session.getSession().adminUser || session.role() === 'admin') {
            let payload = JSON.parse(JSON.stringify(this.accountData));
            payload.oldNickname = this.accountData.nickname;
            payload.nickname = this.newDisplayName;
            payload.updated_from = 'nickName';
            let response = await update('Account', payload, this.accountData.id);
            if (response.error) {
              this.snackbar = {
                show: true,
                color: 'red',
                text: `Failed to update the display name, ${response.error}`
              };
            } else {
              this.accountData = response.data;
              this.family.nickname = this.newDisplayName;
              this.displayNameFlag = false;
              this.selectedDisplayName = false;
              /* Update the state - SearchResult */
              if (this.searchResultIndex > -1) {
                this.SearchResult[this.searchResultIndex].nickname = this.newDisplayName;
              }            
              swal.fire({
                type: 'success',
                title: '<b>Success</b>',
                html: 'The display name was updated successfully',
                showConfirmButton: false,
                timer: 2500,
                onClose: async () => {
                  this.family.username = this.newUsername;
                  if (this.preUrl) {
                    this.$router.push({ path: '/admin/families' });
                  } else {
                    this.displayNameFlag = false;
                    this.selectedDisplayName = false;
                  }
                }
              });
            }
          } else {
            /* Send the change request if parent requests */
            let requestPayload = {
              account: this.accountData.id,
              type: 'Nickname',
              old_value: this.accountData.nickname,
              new_value: this.newDisplayName
            };
            let response = await create('DataUpdateRequest', requestPayload);
            if (response.error) {
              this.snackbar = {
                show: true,
                color: 'red',
                text: `Failed to send the display name change request, ${response.error}`
              };
            } else {
              this.pendingRequest = response.data;
              swal.fire({
                type: 'success',
                title: '<b>Success</b>',
                html: 'The display name change request was submitted successfully',
                showConfirmButton: false,
                timer: 2500,
                onClose: async () => {
                  if (this.preUrl) {
                    this.$router.push({ path: '/admin/families' });
                  } else {
                    this.displayNameFlag = false;
                    this.selectedDisplayName = false;
                  }
                }
              });
            }
          }
        }
      }
    },
    async duplicateUserNameCheck () {
      if (this.newUsername && this.newUsername.trim() !== this.family.username) {
          this.usernameFlag = false;
          if (this.newUsername.length && await checkWPToken()) {
            const usernameUrl = `${this.config.WPParams.api.url}pf/v1/usernameexists?username=${this.newUsername}`;
            const response = await requestToWPPF(usernameUrl, 'GET');
            if (response.error) {
              console.log(response.error);
            } else {
              if (response.count > 0) {
                swal.fire({
                  title: 'The username already exists',
                  type: 'error',
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Close',
                  allowOutsideClick: false
                }).then((result) => {
                  if (result.value) {
                    this.newUsername = this.family.username;
                  }
                  return false;
                });
                return false;
              } else {
                this.usernameFlag = true;
              }
            }
          }
      }
      return true;
    },
    async duplicateDisplayNameCheck () {
      if (this.newDisplayName && this.newDisplayName.trim() !== this.family.nickname) {
        this.displayNameFlag = false;
        if (this.newDisplayName.length && await checkWPToken()) {
          const usernameUrl = `${this.config.WPParams.api.url}pf/v1/nicenameexists?nicename=${this.newDisplayName}`;
          const response = await requestToWPPF(usernameUrl, 'GET');
          if (response.error) {
            console.log(response.error);
          } else {
            if (response.count > 0) {
              swal.fire({
                title: 'The display name exists, please choose another one',
                type: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Close',
                allowOutsideClick: false
              }).then((result) => {
                if (result.value) {
                  this.newDisplayName = this.family.nickname;
                }
                return false;
              });
              return false;
            } else {
              /* Check the duplication in DataUpdateRequest */
              let where = { type: 'Nickname', status: 'Pending', new_value: this.newDisplayName };
              let { error, data } = await getCollection('DataUpdateRequest', true, 0, '', where);
              if (error) {
                console.log(error);
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'Failed to check the display name duplication'
                };
              } else if (data && data.length) {
                swal.fire({
                  title: 'The display name exists, please choose another one',
                  type: 'error',
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Close',
                  allowOutsideClick: false
                }).then((result) => {
                  if (result.value) {
                    this.newDisplayName = this.family.nickname;
                  }
                  return false;
                });
                return false;
              } else {
                this.displayNameFlag = true;
              }
            }
          }
        }
      }
      return true;
    },
    changedUsername () {
      if (this.newUsername && this.newUsername.trim() !== this.family.username) {
        this.selectedUsername = true;
      } else {
        this.selectedUsername = false;
      }
    },
    changedDisplayName () {
      if (this.newDisplayName && this.newDisplayName.trim() !== this.family.nickname) {
        this.selectedDisplayName = true;
      } else {
        this.selectedDisplayName = false;
      }
    },
    hideButtons (type) {
      if (this.preUrl) {
        this.$router.push({ path: '/admin/families' });
      } else {
        // this.$refs.usernameForm.reset();
        this.setFamily();
        this[type] = false;
        this[type === 'selectedUsername' ? 'usernameFlag' : 'displayNameFlag'] = false;
      }
    },

  }
};
</script>


<style lang="css" scoped>
  .requiredfield >>> label::before {
    content: "*";
    color: red;
    padding-right:3px;
  }
  .button-container{
    min-height:60px;
  }
  #changeUsername >>> .v-tabs__item--active {
    background: #319d8c !important;
    color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword/changeUsername.vue